import { useQuery } from '@apollo/client';
import { AccountClient } from '@nile/graphql';
import { GET_ALL_EMPLOYEES } from '@nile/banyan/src/Graphql/Mutations/employee';
import {
  HeaderTag,
  Icon,
  getTranslatedText,
  BackgroundIcon,
  DATE_PICKER_DATE_FORMAT,
  DATE_TIME_FORMAT,
  AccessControl,
  useProduct
} from '@nile/components';
import { GET_ALL_TECHS_NEW, GET_TECHNICIANS_BY_CRITERIA } from '@nile/graphql';
import { ClientSelect } from '@nile/mangifera/src/Components/Ticket';
import { SelectUsers } from '@nile/mangifera/src/Pebbles/ChatContainer';
import {
  Store,
  CalendarCheck,
  MapMarkerAlt,
  Users
} from '@styled-icons/fa-solid';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import EmployeesPicker from '@nile/projects/src/Components/Inputs/EmployeesPicker';
import SiteSelect from '@nile/projects/src/Components/Inputs/SiteSelect';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import { ProjectDetailLoading } from '@nile/projects/src/Components/Loading/Cards';
import { FormattedMessage, injectIntl } from 'react-intl';
import {
  RadioButton,
  TextField,
  Button,
  Checkbox,
  Tooltip
} from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { getTechnicianVariables } from '@nile/graphql/src/Constants/variablesResolver';

const TechnicianGroupIconWrapper = styled.div`
  opacity: 0.6;
  margin-right: 10px;
`;

const OwnerHolder = styled.div`
  .container {
    width: 100%;
    margin: 0 10px;
  }
`;

const DateWrapper = styled.div`
  .react-datepicker-wrapper {
    margin: 0 0 0 10px;
    width: 90%;
    .react-datepicker__input-container {
      > input {
        border-bottom: none !important;
      }
    }
  }
`;

const ContentWrapper = styled.div`
  .Superops-Choice {
    display: flex;
    align-items: center;
  }
  .container {
    width: 40%;
    > div {
      border-bottom: none !important;
    }
  }
  .mt20 {
    margin-top: 20px;
  }
`;

const ProjectDetail = (props) => {
  const { intl, isTemplate, site, client, isCreateFromTicket } = props;
  const currentProduct = useProduct();
  // const {
  //   loading: employeeLoading,
  //   data: allEmployees,
  //   error
  // } = useQuery(GET_ALL_EMPLOYEES, { client: AccountClient });

  // const [startDays, setStartDays] = useState('5');
  // const [endDays, setEndDays] = useState(null);

  const [clientEmployees, setClientEmployees] = useState([]);
  const [isShowProjectToClient, setIsShowProjectToClient] = useState(
    props?.showToClient || false
  );
  useEffect(() => {
    if (client?.accountId || site?.id) {
      AccountClient.query({
        query: GET_TECHNICIANS_BY_CRITERIA,
        fetchPolicy: 'network-only',
        variables: getTechnicianVariables({
          clientIds: [client?.accountId],
          siteIds: [site?.id],
          currentProduct,
          isListInfoRequired: true
        })
      }).then((res) => {
        if (res?.data?.getTechnicianList?.userList) {
          setClientEmployees(res.data.getTechnicianList.userList);
        }
      });
    }
  }, [props?.client, site?.id]);

  // if (employeeLoading) return <ProjectDetailLoading />;

  const selectClientHandler = (val, obj) => {
    props.resetErrors('client');
    props.handleChange(obj, 'client');
    props.handleChange(null, 'site');
  };

  const commonSelectionHandler = (val, type) => {
    const { label, value, ...rest } = val;
    props.resetErrors(type);
    if (type === 'owner') {
      const { name, ...others } = rest;
      props.handleChange(others, type);
    } else {
      const { id, name, ...others } = rest;
      props.handleChange({ id, name }, type);
    }
  };

  const membersHandler = (val, type) => {
    const membersList = val.map((member) => {
      const { label, value, name, id, ...rest } = member;
      return rest;
    });
    props.handleChange(membersList, type);
    props.handleChange(membersList, 'addMembers'); // For creation alone - reformat later
  };

  const selectDateHandler = (val, type) => {
    const date = new Date(val);
    const formatted = val ? dayjs(date).format(DATE_TIME_FORMAT) : null;
    // console.log(date); //original
    // console.log(dayjs(date).format(DATE_TIME_FORMAT)); //formatted
    // console.log(dayjs(formatted).toDate()); //back to original
    props.handleChange(formatted, type);
  };

  const setSelectorOptions = (obj) => {
    if (obj) {
      return { ...obj, label: obj?.name, value: obj?.name };
    }
    return obj;
  };

  const showProjectToClient = (data) => {
    props.handleChange(data, 'showToClient');
    setIsShowProjectToClient(data);
  };

  return (
    <div className="mt40 mb40">
      <div className="flex">
        <HeaderTag
          title={getTranslatedText(intl, 'ticket.newProject.h2.details')}
          isBgStrip
          isNewLayout
        />
      </div>
      <ContentWrapper>
        {isTemplate ? (
          <div className="flex">
            <div className="w30">
              <div className="Polaris-Labelled__LabelWrapper">
                <div className="Polaris-Label">
                  <label
                    id="userPhoneLabel"
                    htmlFor="userPhone"
                    className="Polaris-Label__Text"
                  >
                    <FormattedMessage id="admin.projectTemplate.startDate" />
                  </label>
                </div>
              </div>
              <div className="mt-10">
                <div>
                  <RadioButton
                    label={
                      <FormattedMessage id="admin.projectTemplate.startDate.creation" />
                    }
                    name="startDate"
                    value="CUSTOM"
                    checked={props?.scheduledStartDate?.unit === 'CUSTOM'}
                    onChange={(val) =>
                      val &&
                      props.handleChange(
                        { unit: 'CUSTOM', value: 'TODAY' },
                        'scheduledStartDate'
                      )
                    }
                  />
                </div>
                <div>
                  <RadioButton
                    label={
                      <div className="flex actr">
                        <FormattedMessage id="admin.projectTemplate.startDate.custom" />
                        &nbsp;
                        <TextField
                          value={props?.scheduledStartDate?.value}
                          suffix={getTranslatedText(
                            intl,
                            'admin.projectTemplate.startDate.custom.days'
                          )}
                          size="extrasmall"
                          type="number"
                          min={0}
                          onChange={(val) =>
                            props.handleChange(
                              { unit: 'DAY', value: val },
                              'scheduledStartDate'
                            )
                          }
                          onBlur={(event) => {
                            if (parseInt(event.target.value, 10) < 0) {
                              props.handleChange(
                                { unit: 'DAY', value: '0' },
                                'scheduledStartDate'
                              );
                            } else {
                              const days = Math.round(
                                parseInt(event.target.value, 10)
                              );
                              props.handleChange(
                                {
                                  unit: 'DAY',
                                  value: (Number.isNaN(days)
                                    ? ''
                                    : days
                                  )?.toString()
                                },
                                'scheduledStartDate'
                              );
                            }
                          }}
                        />
                      </div>
                    }
                    name="startDate"
                    value="DAY"
                    checked={props?.scheduledStartDate?.unit === 'DAY'}
                    onChange={(val) =>
                      val &&
                      props.handleChange(
                        { unit: 'DAY', value: '0' },
                        'scheduledStartDate'
                      )
                    }
                  />
                </div>
              </div>
            </div>
            <div className="w30">
              <div className="Polaris-Labelled__LabelWrapper">
                <div className="Polaris-Label">
                  <label
                    id="userPhoneLabel"
                    htmlFor="userPhone"
                    className="Polaris-Label__Text"
                  >
                    <FormattedMessage id="admin.projectTemplate.endDate" />
                  </label>
                </div>
              </div>
              <div className="flex actr mt-10">
                <FormattedMessage id="admin.projectTemplate.endDate.custom" />
                &nbsp;
                <TextField
                  value={props?.dueDate?.value}
                  suffix={getTranslatedText(
                    intl,
                    'admin.projectTemplate.endDate.custom.days'
                  )}
                  min={0}
                  onChange={(val) =>
                    props.handleChange({ unit: 'DAY', value: val }, 'dueDate')
                  }
                  onBlur={(event) => {
                    if (parseInt(event.target.value, 10) < 0) {
                      props.handleChange(
                        { unit: 'DAY', value: '0' },
                        'dueDate'
                      );
                    } else {
                      const days = Math.round(parseInt(event.target.value, 10));
                      props.handleChange(
                        {
                          unit: 'DAY',
                          value: (Number.isNaN(days) ? '' : days)?.toString()
                        },
                        'dueDate'
                      );
                    }
                  }}
                  size="extrasmall"
                  type="number"
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="fx mt20">
              <AccessControl
                productToCheck="MSP"
                render={
                  <div className="w30 mb-30" data-qa="projectClient">
                    <>
                      <div className="Polaris-Labelled__LabelWrapper">
                        <div className="Polaris-Label">
                          <label
                            id="userPhoneLabel"
                            htmlFor="userPhone"
                            className="Polaris-Label__Text"
                          >
                            <FormattedMessage id="ticket.newProject.details.client" />
                          </label>
                        </div>
                      </div>
                      <ClientSelect
                        updateField={selectClientHandler}
                        property="accountId"
                        selectedValue={
                          setSelectorOptions(props?.client) || 'client'
                        }
                        errors={props?.errors?.client}
                        icon={Store}
                        // Removing condition as we've introduced custom stage
                        // conditions={{
                        //   joinOperator: 'AND',
                        //   operands: [
                        //     {
                        //       attribute: 'stage',
                        //       operatorValue: 'placeholder.client.status.active'
                        //     }
                        //   ]
                        // }}
                        fetchBefore={!!props?.client}
                        disabled={isCreateFromTicket}
                      />
                    </>
                  </div>
                }
              />
              <div className="w30 mb-30" data-qa="projectSite">
                <>
                  <SiteSelect
                    accountId={props?.client?.accountId}
                    updateSite={(val) => commonSelectionHandler(val, 'site')}
                    site={props.site}
                    errors={props?.errors?.site}
                    icon={MapMarkerAlt}
                    isITProduct={currentProduct === 'IT'}
                    disabled={isCreateFromTicket}
                  />
                </>
              </div>
              <AccessControl
                productToCheck="MSP"
                render={
                  <div className="w30 mb-30" data-qa="projectSite">
                    <div className="pt-30">
                      <Checkbox
                        label={
                          <FormattedMessage id="project.show.project.to.client" />
                        }
                        checked={isShowProjectToClient}
                        onChange={showProjectToClient}
                      />
                    </div>
                  </div>
                }
              />
            </div>
            <div className="fx mt20">
              <OwnerHolder className="w30 mb-30" data-qa="projectOwner">
                <>
                  <div className="Polaris-Labelled__LabelWrapper">
                    <div className="Polaris-Label">
                      <label
                        id="userPhoneLabel"
                        htmlFor="userPhone"
                        className="Polaris-Label__Text"
                      >
                        <FormattedMessage id="ticket.newProject.details.owner" />
                      </label>
                    </div>
                  </div>
                  <SelectUsers
                    updateField={(val) => commonSelectionHandler(val, 'owner')}
                    query={GET_ALL_TECHS_NEW}
                    params={{
                      client: AccountClient,
                      fetchPolicy: 'network-only',
                      variables: {
                        input: {
                          listInfo: {
                            sort: {
                              attribute: 'name',
                              order: 'ASC'
                            }
                          }
                        }
                      }
                    }}
                    methodName="getTechnicianList"
                    value={props?.owner || null}
                    fetchBefore={!!props?.owner}
                    placeholder={getTranslatedText(
                      intl,
                      'ticket.newProject.owner.pl'
                    )}
                    errors={props?.errors?.owner}
                    showAvatar
                    isDisabled={
                      props?.client === null && currentProduct === 'MSP'
                    }
                  />
                </>
              </OwnerHolder>
              <div className="w30 mb-30" data-qa="projectMembers">
                <>
                  <div className="Polaris-Labelled__LabelWrapper">
                    <div className="Polaris-Label">
                      <label
                        id="userPhoneLabel"
                        htmlFor="userPhone"
                        className="Polaris-Label__Text"
                      >
                        <FormattedMessage id="ticket.newProject.details.members" />
                      </label>
                    </div>
                  </div>
                  {props?.client !== null || currentProduct === 'IT' ? (
                    <EmployeesPicker
                      updateUserList={(val) => membersHandler(val, 'members')}
                      selectedItems={props?.members}
                      allUsers={clientEmployees.filter(
                        (emp) => emp.userId !== props?.owner?.userId
                      )}
                      btnText={
                        props?.members?.length > 0
                          ? `${props.members.length} members`
                          : null
                      }
                      icon={
                        <div className="opacity5">
                          <SVGIcon name="TechnicianGroup" color="#323232" />
                        </div>
                      }
                    />
                  ) : (
                    <>
                      <div className="fx actr mt-10">
                        <TechnicianGroupIconWrapper>
                          <SVGIcon name="TechnicianGroup" color="#323232" />
                        </TechnicianGroupIconWrapper>
                        <Tooltip
                          content={
                            <FormattedMessage id="ticket.newProject.details.members.choose" />
                          }
                        >
                          <Button plain>
                            <div>
                              <FormattedMessage id="ticket.newProject.details.members.pl" />
                            </div>
                          </Button>
                        </Tooltip>
                      </div>
                    </>
                  )}
                </>
              </div>
            </div>
            <DateWrapper className="fx mt20 mb-20">
              <div className="w30 mb-30" data-qa="projectStartDate">
                <>
                  <div className="Polaris-Labelled__LabelWrapper">
                    <div className="Polaris-Label">
                      <label
                        id="userPhoneLabel"
                        htmlFor="userPhone"
                        className="Polaris-Label__Text"
                      >
                        <FormattedMessage id="ticket.newProject.details.start" />
                      </label>
                    </div>
                  </div>
                  <div className="fx actr">
                    <div className="opacity5">
                      <SVGIcon name="DatePicker" color="#323232" />
                    </div>

                    <DatePicker
                      selected={
                        props?.scheduledStartDate &&
                        dayjs(props.scheduledStartDate).toDate()
                      }
                      onChange={(date) =>
                        selectDateHandler(date, 'scheduledStartDate')
                      }
                      placeholderText={getTranslatedText(
                        intl,
                        'ticket.newProject.details.date'
                      )}
                      dateFormat={DATE_PICKER_DATE_FORMAT[DATE_TIME_FORMAT]}
                      showTimeInput
                    />
                  </div>
                </>
              </div>
              <div className="w30 mb-30" data-qa="projectDueDate">
                <>
                  <div className="Polaris-Labelled__LabelWrapper">
                    <div className="Polaris-Label">
                      <label
                        id="userPhoneLabel"
                        htmlFor="userPhone"
                        className="Polaris-Label__Text"
                      >
                        <FormattedMessage id="ticket.newProject.details.due" />
                      </label>
                    </div>
                  </div>
                  <div className="fx actr">
                    <div className="opacity5">
                      <SVGIcon name="DatePicker" color="#323232" />
                    </div>

                    <DatePicker
                      selected={props?.dueDate && dayjs(props.dueDate).toDate()}
                      onChange={(date) => selectDateHandler(date, 'dueDate')}
                      placeholderText={getTranslatedText(
                        intl,
                        'ticket.newProject.details.date'
                      )}
                      dateFormat={DATE_PICKER_DATE_FORMAT[DATE_TIME_FORMAT]}
                      showTimeInput
                    />
                  </div>
                </>
              </div>
            </DateWrapper>
          </>
        )}
      </ContentWrapper>
    </div>
  );
};

export default injectIntl(ProjectDetail);
